var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"area-btn head-btn btn",class:_vm.isSelected,style:(_vm.hidden),on:{"pointerdown":function($event){return _vm.selectPart(_vm.part)}}},[_vm._v(_vm._s(_vm.part))])}
var staticRenderFns = []

export { render, staticRenderFns }